import { Slider as MuiSlider } from "@mui/material";
import type { AriaAttributes } from "react";

export type SliderProps = AriaAttributes & {
  min: number;
  max: number;
  value: [number, number];
  onChange: (value: [number, number], source?: "text" | "slider") => void;
  scale?: (value: number) => number;
  valueLabelFormat?: (value: number) => string;
};

export const Slider = ({ onChange, ...props }: SliderProps) => {
  return (
    <MuiSlider
      onChange={(event, newValue) => {
        onChange(newValue as [number, number], "slider");
      }}
      {...props}
    />
  );
};
